<div class="samples-page">
  <div class="samples-header">
    <h2 class="samples-title">
      {{ "samplesPage.title" | translate }}
    </h2>

    <a class="upload-button" routerLink="/home/upload">
      {{ "navigation.uploadData.text" | translate }}
    </a>
  </div>

  <div class="samples-container">
    <div class="table-container">
      <table>
        <thead>
          <!-- Column titles -->
          <tr>
            <th class="sortable" (click)="changeSort('firstname')">
              <span class="header-content">
                {{ "samplesPage.firstName" | translate }}

                <lucide-angular
                  *ngIf="filters.sortBy === 'firstname'"
                  [name]="filters.sortOrder === 'asc' ? 'arrow-up' : 'arrow-down'"
                  [size]="18"
                  class="icon"
                ></lucide-angular>

                <lucide-angular *ngIf="filters.sortBy !== 'firstname'" name="arrow-up" [size]="18" class="icon hover"></lucide-angular>
              </span>
            </th>
            <th class="sortable" (click)="changeSort('name')">
              <span class="header-content">
                {{ "samplesPage.lastName" | translate }}

                <lucide-angular
                  *ngIf="filters.sortBy === 'name'"
                  [name]="filters.sortOrder === 'asc' ? 'arrow-up' : 'arrow-down'"
                  [size]="18"
                  class="icon"
                ></lucide-angular>

                <lucide-angular *ngIf="filters.sortBy !== 'name'" name="arrow-up" [size]="18" class="icon hover"></lucide-angular>
              </span>
            </th>
            <th class="sortable" (click)="changeSort('sampleID')">
              <span class="header-content">
                {{ "samplesPage.sampleId" | translate }}

                <lucide-angular
                  *ngIf="filters.sortBy === 'sampleID'"
                  [name]="filters.sortOrder === 'asc' ? 'arrow-up' : 'arrow-down'"
                  [size]="18"
                  class="icon"
                ></lucide-angular>

                <lucide-angular *ngIf="filters.sortBy !== 'sampleID'" name="arrow-up" [size]="18" class="icon hover"></lucide-angular>
              </span>
            </th>
            <th class="sortable" (click)="changeSort('source')">
              <span class="header-content">
                {{ "samplesPage.source" | translate }}

                <lucide-angular
                  *ngIf="filters.sortBy === 'source'"
                  [name]="filters.sortOrder === 'asc' ? 'arrow-up' : 'arrow-down'"
                  [size]="18"
                  class="icon"
                ></lucide-angular>

                <lucide-angular *ngIf="filters.sortBy !== 'source'" name="arrow-up" [size]="18" class="icon hover"></lucide-angular>
              </span>
            </th>
            <th class="sortable" (click)="changeSort('cancerType')">
              <span class="header-content">
                {{ "samplesPage.cancerType" | translate }}

                <lucide-angular
                  *ngIf="filters.sortBy === 'cancerType'"
                  [name]="filters.sortOrder === 'asc' ? 'arrow-up' : 'arrow-down'"
                  [size]="18"
                  class="icon"
                ></lucide-angular>

                <lucide-angular *ngIf="filters.sortBy !== 'cancerType'" name="arrow-up" [size]="18" class="icon hover"></lucide-angular>
              </span>
            </th>
            <th>{{ "samplesPage.hasRnaSeq" | translate }}</th>
            <th>{{ "samplesPage.hasMutation" | translate }}</th>
            <th class="sortable" (click)="changeSort('completionRate')">
              <span class="header-content">
                {{ "samplesPage.metadataCompletion" | translate }}

                <lucide-angular
                  *ngIf="filters.sortBy === 'completionRate'"
                  [name]="filters.sortOrder === 'asc' ? 'arrow-up' : 'arrow-down'"
                  [size]="18"
                  class="icon"
                ></lucide-angular>

                <lucide-angular *ngIf="filters.sortBy !== 'completionRate'" name="arrow-up" [size]="18" class="icon hover"></lucide-angular>
              </span>
            </th>
            <th class="sortable" (click)="changeSort('createdAt')">
              <span class="header-content">
                {{ "samplesPage.uploadDate" | translate }}

                <lucide-angular
                  *ngIf="filters.sortBy === 'createdAt'"
                  [name]="filters.sortOrder === 'asc' ? 'arrow-up' : 'arrow-down'"
                  [size]="18"
                  class="icon"
                ></lucide-angular>

                <lucide-angular *ngIf="filters.sortBy !== 'createdAt'" name="arrow-up" [size]="18" class="icon hover"></lucide-angular>
              </span>
            </th>
            <th>{{ "samplesPage.actions" | translate }}</th>
          </tr>

          <!-- Filters -->
          <tr class="filters-row">
            <th>
              <input
                class="value-box no-background"
                type="text"
                [(ngModel)]="filters.firstname"
                (keyup.enter)="changeFilter()"
                [placeholder]="('samplesPage.filter' | translate) + '...'"
              />
            </th>

            <th>
              <input
                class="value-box no-background"
                type="text"
                [(ngModel)]="filters.name"
                (keyup.enter)="changeFilter()"
                [placeholder]="('samplesPage.filter' | translate) + '...'"
              />
            </th>

            <th>
              <input
                class="value-box no-background"
                type="text"
                [(ngModel)]="filters.sampleId"
                (keyup.enter)="changeFilter()"
                [placeholder]="('samplesPage.filter' | translate) + '...'"
              />
            </th>

            <th>
              <select class="value-box no-background" [(ngModel)]="filters.source" (change)="changeFilter()">
                <option value="">{{ "samplesPage.all" | translate }}</option>
                <option *ngFor="let s of sources" [value]="s.id">
                  {{ s.name }}
                </option>
              </select>
            </th>

            <th>
              <select class="value-box no-background" [(ngModel)]="filters.cancerType" (change)="changeFilter()">
                <option value="">{{ "samplesPage.all" | translate }}</option>
                <option *ngFor="let c of cancerTypes" [value]="c.id">
                  {{ c.acronym }}
                </option>
              </select>
            </th>

            <th>
              <select class="value-box no-background" [(ngModel)]="filters.hasRnaSeq" (change)="changeFilter()">
                <option value="">{{ "samplesPage.all" | translate }}</option>
                <option value="true">{{ "samplesPage.uploaded" | translate }}</option>
                <option value="false">{{ "samplesPage.missing" | translate }}</option>
              </select>
            </th>

            <th>
              <select class="value-box no-background" [(ngModel)]="filters.hasMutation" (change)="changeFilter()">
                <option value="">{{ "samplesPage.all" | translate }}</option>
                <option value="true">{{ "samplesPage.uploaded" | translate }}</option>
                <option value="false">{{ "samplesPage.missing" | translate }}</option>
              </select>
            </th>

            <th>
              <input
                class="value-box no-background"
                type="number"
                [(ngModel)]="filters.metadataCompletion"
                (keyup.enter)="changeFilter()"
                placeholder="%"
                min="0"
                max="100"
              />
            </th>

            <th>
              <input class="value-box no-background" type="date" [(ngModel)]="filters.uploadDate" (keyup.enter)="changeFilter()" />
            </th>

            <th>
              <button class="value-box no-background" (click)="clearFilters()">{{ "samplesPage.clear" | translate }}</button>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let sample of dataSource.data$ | async" [ngStyle]="(dataSource.loading$ | async) ? { display: 'none' } : {}">
            <td>{{ sample.firstname || "-" }}</td>

            <td>{{ sample.name || "-" }}</td>

            <td>{{ sample.sampleID }}</td>

            <td>{{ sample.source }}</td>

            <td>{{ sample.cancerType }}</td>

            <td>
              <span class="badge badge-uploaded" *ngIf="sample.hasRnaSeq">
                <lucide-angular name="circle-check-big" [size]="16" class="icon icon-green"></lucide-angular>
                {{ "samplesPage.uploaded" | translate }}
              </span>
              <span class="badge badge-missing" *ngIf="!sample.hasRnaSeq">
                <lucide-angular name="circle-alert" [size]="16" class="icon icon-red"></lucide-angular>
                {{ "samplesPage.missing" | translate }}
              </span>
            </td>

            <td>
              <span class="badge badge-uploaded" *ngIf="sample.hasMutation">
                <lucide-angular name="circle-check-big" [size]="16" class="icon icon-green"></lucide-angular>
                {{ "samplesPage.uploaded" | translate }}
              </span>
              <span class="badge badge-missing" *ngIf="!sample.hasMutation">
                <lucide-angular name="circle-alert" [size]="16" class="icon icon-red"></lucide-angular>
                {{ "samplesPage.missing" | translate }}
              </span>
            </td>

            <td>
              <span class="badge metadata-badge" [ngClass]="getCompletionBadge(sample.metadataCompletion)">
                {{ sample.metadataCompletion }}%
              </span>
            </td>

            <td>{{ sample.date | date: "dd/MM/yyyy" }}</td>

            <td class="actions">
              <a [routerLink]="['/home/metadata', sample.id]" class="nav-link">
                <lucide-angular name="search" [size]="18" class="icon icon-green"></lucide-angular>
              </a>
              <a *ngIf="canModifyData" [routerLink]="['/home/metadata', sample.id]" [queryParams]="{ edit: true }" class="nav-link">
                <lucide-angular name="square-pen" [size]="18" class="icon icon-blue"></lucide-angular>
              </a>
              <button *ngIf="canUploadRnaMutation" type="button" class="nav-link action-button" (click)="openUploadModal(sample)">
                <lucide-angular name="upload" [size]="18" class="icon icon-purple"> </lucide-angular>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- LOADER MANAGEMENT -->
      <div class="spinner-container" *ngIf="dataSource.loading$ | async">
        <div class="spinner"></div>
      </div>
    </div>
  </div>

  <div class="samples-footer">
    <!-- PAGINATOR MANAGEMENT -->
    <div class="pagination" [style.visibility]="(dataSource.loading$ | async) ? 'hidden' : 'visible'">
      <div class="pagination-info">
        {{ "samplesPage.showing" | translate }}
        {{ displayedStart }}
        -
        {{ displayedEnd }}
        {{ "samplesPage.of" | translate | lowercase }}
        {{ totalCount }}
      </div>

      <div class="pagination-controls">
        <button (click)="changePage(1)" [disabled]="currentPage === 1">
          <lucide-angular name="chevron-first" [size]="18" class="icon"></lucide-angular>
        </button>

        <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">
          <lucide-angular name="chevron-left" [size]="18" class="icon"></lucide-angular>
        </button>

        <span class="page-number">
          {{ "samplesPage.page" | translate }}
          <input
            class="value-box no-background"
            type="number"
            [value]="currentPage"
            min="1"
            [max]="nbPages"
            (keyup.enter)="goToPage($event)"
          />
          {{ "samplesPage.of" | translate | lowercase }}
          {{ nbPages }}
        </span>

        <button (click)="changePage(currentPage + 1)" [disabled]="currentPage >= nbPages">
          <lucide-angular name="chevron-right" [size]="18" class="icon"></lucide-angular>
        </button>

        <button (click)="changePage(nbPages)" [disabled]="currentPage >= nbPages">
          <lucide-angular name="chevron-last" [size]="18" class="icon"></lucide-angular>
        </button>
      </div>

      <div class="page-size">
        <label for="pageSize">{{ "samplesPage.samplesPerPage" | translate }}:</label>

        <select class="value-box no-background" id="pageSize" [(ngModel)]="currentPageSize" (change)="changePageSize(currentPageSize)">
          <option *ngFor="let size of pageSizeOptions" [value]="size">
            {{ size }}
          </option>
        </select>
      </div>
    </div>
  </div>
</div>

<div class="modal-backdrop" *ngIf="isUploadModalOpen">
  <div class="modal-content">
    <button class="modal-close" type="button" (click)="closeUploadModal()">×</button>

    <div class="information">
      {{ "samplesPage.uploadInfo" | translate }}
    </div>

    <div #feedbackContainer class="upload-feedback" *ngIf="messages.length > 0">
      <div *ngFor="let msg of messages" class="feedback-message">
        {{ msg }}
      </div>
    </div>

    <app-rna-mutation-upload
      [isModal]="true"
      [initialBiobankName]="selectedSample?.source"
      [initialSampleId]="selectedSample?.sampleID"
      (messagesChanged)="messages = $event"
      (uploadingChange)="isUploading = $event"
      (uploadSuccess)="loadData()"
    >
    </app-rna-mutation-upload>
  </div>
</div>

<div class="modal-backdrop" *ngIf="isUploading">
  <div class="loader-container">
    <div class="dots-row">
      <div class="dot" *ngFor="let dot of dots" [@fadeInOut]></div>
    </div>
    <div class="loader-text">{{ "uploadData.fileUploading" | translate }}</div>
  </div>
</div>
